<div class="downloads-section">
  <label class="sub-header">{{
    "projectDetails.downloads.title" | translate
  }}</label>
  @if (documents().length > 0) {
    <app-downloadable-file-list [files]="documents()" />
  } @else {
    <p class="no-content">
      {{ "projectDetails.downloads.noDocuments" | translate }}
    </p>
  }
</div>
